export const convertDate = (date) => {

  if (date === "") {
    return null
  }

  const newDate = new Date(date);

  let day = newDate.getDate();
  let month = newDate.getMonth() + 1; // Months are 0-indexed in JavaScript
  let year = newDate.getFullYear();
  
  // Ensure day and month are two-digits
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  
  return `${year}-${month}-${day}`; // "2023-05-24"
  
};

